import Logo from '@assets/logos/swise_white_on_dark.svg';
import { Outlet } from 'react-router-dom';
import {
  InfoIntroContainer,
  StyledLogo,
  FormContainer,
  Container,
  StyledIntroImage,
} from './AuthBase.styles';
import AuthIntroImage from '@assets/logos/auth-intro-image.png';
import { Flex, Text } from '@components';
import { useTheme } from '@mui/material';
import { FormattedMessage } from 'react-intl';

export const AuthBase = (): JSX.Element => {
  const theme = useTheme();
  return (
    <Container>
      <InfoIntroContainer>
        <StyledLogo alt='auth-carousel-image' src={Logo} />
        <Flex flexDirection='column' paddingY={12} paddingX={17}>
          <StyledIntroImage src={AuthIntroImage} />
          <Flex flexDirection='column' textAlign='center'>
            <Text
              variant='h4'
              fontWeight='fontWeightMedium'
              color={theme.palette.common.white}
            >
              <FormattedMessage id='signUp.leftPanel.title' />
            </Text>
            <Text
              variant='h6'
              fontWeight='fontWeightRegular'
              mt={6}
              color={theme.palette.black[100]}
            >
              <FormattedMessage id='signUp.leftPanel.subtitle' />
            </Text>
          </Flex>
        </Flex>
      </InfoIntroContainer>
      <FormContainer>
        <Outlet />
      </FormContainer>
    </Container>
  );
};
